// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q2/2023hlsqzdy_water/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getLimitInfo = () => {
  return http.get(`${urlPrefix}limit-vote`);
};
const saveinfo = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};
const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};
const voteList = (page: any, search: any) => {
  return http.get(
    `${urlPrefix}vote-list&search=${search}&page=${page}`,
  );
};


export { getBaseInfo, saveinfo, getRule, voteList, getLimitInfo };
